import React from 'react';
import classnames from 'classnames';

const ModalCardFoot = ({ children, className, ...props }) => {
  return (
    <footer {...props} className={classnames('modal-card-foot', className)}>
      {children}
    </footer>
  );
};

export default ModalCardFoot;
